import * as React from 'react'

function SvgConfirmationEmail({ title, titleId, ...props }) {
  return (
    <svg width={87} height={73} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path
          fill="#315CAA"
          d="M75.011 20L85 28.083v39.448C85 69.447 83.43 71 81.495 71h-60.99C18.569 71 17 69.447 17 67.531V28.083L26.99 20h48.02z"
        />
        <path
          fill="#F9FCEB"
          d="M27 36.121V5.46C27 3.549 28.568 2 30.504 2h40.992C73.432 2 75 3.549 75 5.459V36.12L51 54 27 36.121z"
        />
        <path
          fill="#62BD54"
          d="M63 25c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12"
        />
        <path
          fill="#223A76"
          d="M25.53 32.634l-5.673-4.303 5.674-4.628v8.931zm-6.559-.733l20.024 15.187L18.97 67.063V31.901zm32.154 23.955c.361 0 .722-.115 1.025-.344l8.387-6.36 20.522 20.471H21.192l20.522-20.472 8.387 6.361c.302.23.663.344 1.024.344zM76.72 23.703l5.675 4.628-5.675 4.303v-8.931zm6.56 43.36L63.256 47.088 83.28 31.9v35.162zm2.762-40.118L76.72 19.34V5.236c0-2.85-2.325-5.169-5.182-5.169H57.894a1.69 1.69 0 100 3.377h13.644c.99 0 1.797.805 1.797 1.792v29.966l-22.21 16.845-22.21-16.845V5.236c0-.987.807-1.792 1.798-1.792h13.643a1.69 1.69 0 001.692-1.688A1.69 1.69 0 0044.356.067H30.713c-2.858 0-5.182 2.32-5.182 5.17V19.34l-9.323 7.604c-.393.32-.621.8-.621 1.307v18.743H7.97a1.69 1.69 0 00-1.692 1.688 1.69 1.69 0 001.692 1.689h7.616V67.83c0 2.85 2.324 5.17 5.18 5.17h60.715c2.858 0 5.182-2.32 5.182-5.17V28.252c0-.506-.228-.986-.622-1.307z"
        />
        <path
          fill="#223A76"
          d="M11.243 57H1.757C.786 57 0 57.895 0 59c0 1.104.786 2 1.757 2h9.486c.97 0 1.757-.896 1.757-2 0-1.105-.787-2-1.757-2"
        />
        <path
          fill="#62BD54"
          d="M61.672 24.5c0 5.609-4.563 10.172-10.172 10.172-5.61 0-10.172-4.563-10.172-10.172 0-5.61 4.562-10.172 10.172-10.172S61.672 18.891 61.672 24.5M38 24.5C38 31.944 44.056 38 51.5 38S65 31.944 65 24.5 58.944 11 51.5 11 38 17.056 38 24.5"
        />
        <path
          fill="#FFF"
          d="M48.985 23.55c-.683-.612-1.79-.612-2.473 0-.683.613-.683 1.607 0 2.22l3.087 2.77c.342.306.789.46 1.236.46.448 0 .895-.154 1.237-.46l5.417-4.861c.681-.613.681-1.607 0-2.219-.684-.613-1.791-.613-2.474 0l-4.18 3.751-1.85-1.66z"
        />
      </g>
    </svg>
  )
}

export default SvgConfirmationEmail
